import styled from 'styled-components';

const Container = styled.div<{
    fontSize: number;
    fontColor: string;
    fontWeight: string;
    backgroundColor: string;
    styleSiteTextAlign: string;
    styleShowReportTextAlign: string;
}>`
    font-size: ${({ fontSize }) => `${fontSize}%`};
    background-color: ${({ backgroundColor }) => backgroundColor};
    color: ${({ fontColor }) => fontColor};
    height: 100%;
    padding: 0;
    position: relative;
    display: flex;

    .wrapper {
        justify-content: space-around;
        align-items: center;
        display: flex;
        width: 100%;
    }

    .flex-1 {
        text-align: center;
        flex: 1;
        font-size: ${({ fontSize }) => `${fontSize}%`};
        padding: 10px;
    }
    .site {
        text-align: ${({ styleSiteTextAlign }) => styleSiteTextAlign};
    }
    .show-report {
        text-align: ${({ styleShowReportTextAlign }) => styleShowReportTextAlign};
    }

    .header-h {
        color: ${(props) => props.fontColor} !important;
        font-weight: ${({ fontWeight }) => fontWeight};
        margin: 0;
        font-size: ${({ fontSize }) => `${fontSize * 1.2}%`};
        text-align: left;
    }
`;

const StyleHeaderImg = styled.div`
    padding: 10px 0 20px 0;
    height: 100%;
    width: 20%;
    img {
        height: 100%;
        object-fit: contain;
        width: 100%;
    }
`;

export { Container, StyleHeaderImg };
